import angular from "angular";
import reportService from './report.service';

let reportModule = angular.module('report.service', [])
.service('Report', reportService)

.name;

export default reportModule;



// WEBPACK FOOTER //
// ./client/app/services/reportService/report.js